import { render, staticRenderFns } from "./PageBecomeCreator.vue?vue&type=template&id=eb237778&"
import script from "./PageBecomeCreator.vue?vue&type=script&lang=ts&"
export * from "./PageBecomeCreator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports